import { combineReducers } from 'core/redux'

import kbSearch from './kbSearch'

export default combineReducers({
  kbSearch,
})
